// Utils for the customer area

import React from "react";
import { elementsToSentence } from "../../../../shared/helpers/stringHelpers";

export const officePhone = <a href="tel:+441173257898">+44 (0)117 325 7898</a>;

export const officeHours = (
  <span>
    Mon - Fri, 9am to 5:30pm (
    <a href="https://www.timeanddate.com/worldclock/uk/bristol" target="_blank" rel="noreferrer">
      UK time
    </a>
    )
  </span>
);

export const teamEmail = <a href="mailto:team@travellocal.com">team@travellocal.com</a>;

export const isEnquiryBooked = (enquiry: IEnquiry): boolean => {
  return enquiry.bookedTime != null;
};

export const getVisaLinksFragment = (itinerary: Pick<IItinerarySummary, "countries" | "primaryLocation">) => {
  if (!itinerary) {
    return;
  }

  const visaLinks = (itinerary.countries || []).map(country => {
    const link = (country.externalLinks || []).find(l => l.label === "visa");
    if (!link) {
      return;
    }

    return (
      <a key={country.id} href={link.url} target="_blank" rel="noreferrer">
        {country.name}
      </a>
    );
  });

  if (visaLinks.length) {
    return elementsToSentence(visaLinks, "or");
  }

  if (itinerary.primaryLocation) {
    return itinerary.primaryLocation.name;
  }
};
